import ProjectPage from "./ProjectPage";
import { ONE_WORLD, NEOPOLIS } from "../content";

export default function Home() {
  return <ProjectPage project={ONE_WORLD} other={NEOPOLIS} />;
}
